import { Component, Input, OnInit } from '@angular/core';
import { StateAssociationArticle } from '../../../../features/application/models/application.model';
import { CompanyType } from '../../../../core/constants/company-type.enum';
import { constitutionalDocumentTitle } from '../../../../core/helpers/constitutional-document-title';

@Component({
    selector: 'app-aoa-section',
    templateUrl: './aoa-section.component.html',
    styleUrls: ['./aoa-section.component.scss'],
    standalone: false
})
export class AoaSectionComponent implements OnInit {
  @Input() associationArticle: StateAssociationArticle | undefined;
  @Input() associationArticleByLaws: StateAssociationArticle | undefined;
  @Input() opfCode: CompanyType | undefined;

  ngOnInit(): void {
  }

  get aoaText(): string {
    return this.aoaOptionsText(this.associationArticle, this.title) || '';
  }

  get aoa2Text(): string {
    return this.aoaOptionsText(this.associationArticleByLaws, 'By-Laws') || '';
  }
  
  private aoaOptionsText(aoa:StateAssociationArticle | undefined, title: string): string {
    return aoa?.isBespoke || aoa?.bespokeAgreement
      ? `I wish to adopt bespoke ${title}` 
      : aoa?.isModel 
        ? `I wish to adopt a standard ${title}` : "Not selected";
  }

  get title(): string {
    return constitutionalDocumentTitle(this.opfCode);
  }
}